const Animations = {
  VFSpinerRed: require('../Images/Animations/spinnerRed.json'),
  VFSpinerWhite: require('../Images/Animations/spinnerWhite.json'),
}

export default Animations
